<div class="view-panel">
  <div class="view-panel__header" *ngIf="showHeader">
    <div class="view-panel__label">
      {{ label }}
    </div>
    <ng-content class="view-panel__actions" select="[actions]" actions></ng-content>
  </div>
  
  <ng-content></ng-content>
</div>